import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './EmailForm.css';
import ProductGlimpse from './ProductGlimpse';
import logo from '../assets/SnohAI logo (1).png';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const EmailForm = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [product, setProduct] = useState('');
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const productParam = queryParams.get('product');
  if (productParam && productParam.trim() !== '') {
    setProduct(productParam);
  } else {
    window.location.href = 'https://snohai.com/products/';
  }
}, [location.search]);

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const productParam = queryParams.get('product');
  //   if (productParam) {
  //     setProduct(productParam);
  //   }
  // }, [location.search]);

  const validateEmail = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return 'Enter your email address to continue.';
    if (!EMAIL_PATTERN.test(trimmed)) return 'Enter an email address like you@company.com.';
    return '';
  };

  const handleBlur = () => {
    if (email) setError(validateEmail(email));
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateEmail(email);
    if (validationError) {
      setError(validationError);
      return;
    }

    setError('');
    setLoading(true);

    try {
      const response = await axios.post(
        'https://login.snohai.com/api/auth/redirect',
        { email, product }
      );

      // Prefer server-built URL (server now returns { url, username, route })
      const { url, username, route, redirectUrl = '' } = response.data;

      if (url) {
        // Server already encoded token into the URL; navigate directly.
        window.location.href = url;
        return;
      }

      // Fallback to prior client-side construction using route/username or redirectUrl
      const token = username; // username field contains the raw JWT token from server
      const tenant = route || '';
      let finalUrl = '';

      const pathAndQuery = redirectUrl.startsWith(tenant) ? redirectUrl.slice(tenant.length) : redirectUrl;
      const ensureLeadingSlash = (s) => (s ? (s.startsWith('/') ? s : '/' + s) : '');
      const appendTokenToUrl = (u) => {
        if (!token) return u;
        return u.includes('?') ? `${u}&username=${encodeURIComponent(token)}` : `${u}?username=${encodeURIComponent(token)}`;
      };

      if (tenant && tenant.includes('.')) {
        finalUrl = `https://${product}.snohai.com/${tenant}${ensureLeadingSlash(pathAndQuery)}`;
        finalUrl = appendTokenToUrl(finalUrl);
      } else if (tenant) {
        finalUrl = `https://${tenant}-${product}.snohai.com${ensureLeadingSlash(pathAndQuery)}`;
        finalUrl = appendTokenToUrl(finalUrl);
      } else {
        if (redirectUrl.includes('.')) {
          const [path, query] = redirectUrl.split('?');
          const cleanedPath = path.replace(new RegExp(`-${product}(?=/|$)`), '');
          finalUrl = `https://${product}.snohai.com/${cleanedPath}${query ? '?' + query : ''}`;
        } else {
          const [subdomain, ...rest] = redirectUrl.split('/');
          finalUrl = `https://${subdomain}-${product}.snohai.com${rest.length ? '/' + rest.join('/') : ''}`;
        }
      }

      window.location.href = finalUrl;

    } catch (error) {
      setLoading(false);
      setError(
        error.response?.data?.message || 'An error occurred. Please try again.'
      );
    }
  };


  return (
    <div className="snoh-page">
      <aside className="snoh-brand">
        <div className="snoh-brand-inner">
          <p className="snoh-eyebrow">let Snoh handle it&hellip;</p>
          <h2 className="snoh-headline">One AI Platform. Endless Business Possibilities.</h2>

          <ProductGlimpse />
        </div>
      </aside>

      <main className="snoh-panel">
        <div className="snoh-form-wrap">
          <img src={logo} alt="SnohAI" className="snoh-logo" />

          <h1 className="snoh-title">Sign in</h1>
          <p className="snoh-subtitle">
            Enter your work email and we&rsquo;ll take you to your workspace.
          </p>

          <form onSubmit={handleSubmit} className="snoh-form" noValidate>
            <label className="snoh-label" htmlFor="snoh-email">
              Email address
            </label>
            <input
              id="snoh-email"
              type="email"
              value={email}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`snoh-input${error ? ' snoh-input--invalid' : ''}`}
              placeholder="you@company.com"
              autoComplete="email"
              inputMode="email"
              spellCheck="false"
              autoFocus
              aria-invalid={error ? 'true' : 'false'}
              aria-describedby={error ? 'snoh-email-error' : undefined}
              disabled={loading}
            />

            <p className="snoh-error" id="snoh-email-error" role="alert">
              {error}
            </p>

            <a href="#" className="snoh-help-link">
              Can&rsquo;t access your account?
            </a>

            <button type="submit" className="snoh-submit" disabled={loading}>
              <span>Next</span>
              {loading ? (
                <span className="snoh-spinner" aria-hidden="true" />
              ) : (
                <svg className="snoh-arrow" viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M3 10h13M11 5l5 5-5 5" />
                </svg>
              )}
            </button>
          </form>

          <footer className="snoh-footer">
            <a href="#">Terms of use</a>
            <span aria-hidden="true">&middot;</span>
            <a href="#">Privacy &amp; cookies</a>
          </footer>
        </div>
      </main>
    </div>
  );
};

export default EmailForm;
